import { render, staticRenderFns } from "./SectionDeclaration.vue?vue&type=template&id=0d8b0ee4&"
import script from "./SectionDeclaration.vue?vue&type=script&lang=js&"
export * from "./SectionDeclaration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports